const readEnv = (key: keyof ImportMetaEnv): string | undefined => {
  const value = import.meta.env[key];
  if (typeof value !== "string") return undefined;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
};

const requireEnv = (key: keyof ImportMetaEnv, purpose: string): string => {
  const value = readEnv(key);
  if (!value) {
    throw new Error(
      `[runtimeEnv] Missing ${key}. ${purpose} Add it to your .env file (see .env.example and environment-specific examples).`,
    );
  }
  return value;
};

export const runtimeEnv = {
  getSupabaseClientConfig: () => ({
    url: requireEnv(
      "VITE_SUPABASE_URL",
      "Supabase client cannot initialize without the project URL.",
    ),
    publishableKey: requireEnv(
      "VITE_SUPABASE_PUBLISHABLE_KEY",
      "Supabase client cannot initialize without the publishable key.",
    ),
  }),

  getBackendAdminBaseUrl: () =>
    requireEnv(
      "VITE_BACKEND_API_URL",
      "Backend admin service cannot call /health, /heartbeat, or /v1/routes without this base URL.",
    ).replace(/\/$/, ""),
};
